export const features = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量影视资源',
    description: '收录超过10万部电影、电视剧、综艺、动漫资源，涵盖国内外热门内容，每日实时更新最新剧集，让你永远不剧荒。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清流畅播放',
    description: '支持1080P、4K超清画质播放，智能CDN加速技术确保播放流畅不卡顿，低网速下也能自动适配清晰度。',
  },
  {
    id: 3,
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存下载',
    description: '支持一键离线缓存，无需网络也能随时随地观看。智能存储管理，自动清理缓存释放手机空间。',
  },
  {
    id: 4,
    icon: 'ri-smartphone-line',
    title: '全平台兼容',
    description: '完美适配安卓和苹果系统，支持手机、平板等多种设备。界面简洁直观，操作便捷，老少皆宜。',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    description: '经过严格安全检测，无毒无插件。纯净观影体验，无弹窗广告干扰，专注内容本身。',
  },
  {
    id: 6,
    icon: 'ri-translate-2',
    title: '多语言字幕',
    description: '支持中英日韩等多语言字幕切换，部分资源提供双语字幕。追剧学习两不误，满足不同用户需求。',
  },
];

export const statsData = [
  { value: '5000万+', label: '累计用户' },
  { value: '10万+', label: '影视资源' },
  { value: '99.8%', label: '播放成功率' },
  { value: '4.9分', label: '用户评分' },
];